import { Directive, ElementRef, Input, HostListener, Renderer2, AfterViewChecked } from '@angular/core';

@Directive({
    selector: '[atx-affix]'
})

export class AtxAffixDirective implements AfterViewChecked {
    @Input() public offset: number = 0;
    @Input() public addClass: string = 'w-100';
    @Input() public readonly isOffsetParentTop: boolean = true;

    private sticked: boolean = true;
    private selectedOffset: number = 0;
    private windowOffsetTop: number = 0;

    constructor(
        private readonly el: ElementRef,
        private readonly render: Renderer2
    ) {}

    public ngAfterViewChecked() {
        const { offsetParent } = this.el.nativeElement;

        if (offsetParent && this.selectedOffset != offsetParent.offsetTop) {
            this.selectedOffset = offsetParent.offsetTop;
        }
    }

    private addSticky() {
        this.sticked = true;
        this.el.nativeElement.style.position = 'fixed';
        this.el.nativeElement.style.top = this.offset + 'px';
        this.render.addClass(this.el.nativeElement, this.addClass);
    }

    private removeSticky() {
        this.sticked = false;
        this.el.nativeElement.style.position = '';
        this.render.removeClass(this.el.nativeElement, this.addClass);
    }

    @HostListener("window:scroll", [])
    onWindowScroll() {
        this.windowOffsetTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

        console.log((this.windowOffsetTop + this.offset), this.selectedOffset);

        if ((this.windowOffsetTop + this.offset) > this.selectedOffset) {
            this.addSticky();
        } else {
            this.removeSticky();
        }
    }
}
